<template>
  <form v-on:submit.prevent="otpSubmit()" class="box orange left-box-sizing text-left">
    <!-- box header -->
    <div class="header">
      <span class="step mx-2 mx-md-4">1</span>
      <h2>Delivery Information</h2>
    </div>

    <!-- box-content -->
    <div class="content">
      <div class="px-3 px-lg-5">
        <div class="form">
          <div class="mb-4">
            Verify the OTP sent to +91{{this.phone}}
          </div>
          <div class="row w-100">
            <div class="col-12">
              <div class="">
                <div class="input-group">
                  <input class="text w-100" type="number" name="otp" id="otp" v-model="$v.otp.$model" required>
                  <label :class="[$v.otp.$model=='' ? '' : 'filled', 'label']" for="otp">Enter OTP</label>
                </div>
                <small v-if="$v.otp.$dirty && $v.otp.$invalid" class="input-error text-danger">(Please enter a valid 6 digit OTP)</small>
                <small v-else-if="this.invalidOTP" class="input-error text-danger">(OTP does not match. Please re-enter)</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- box footer -->
    <div class="footer">
      <!-- <form name="delivery" v-on:submit.prevent="proceed()" class="px-3"> -->
      <div class="px-3 form">
        <small class="mx-2 ml-md-5" style="color: #909090;">
          <button type="button" @click.prevent="otpSend()" class="resend" :disabled="resendDisabled">Resend</button>
          <span v-if="resendDisabled">
            in
            <b class="text-dark">{{ secondsLeft }}</b>
            (seconds)
          </span>
        </small>
        <input
          class="mx-sm-auto ml-md-auto mr-md-0"
          type="submit"
          value="Continue"
          :disabled="$v.$invalid"
        >
      </div>
      <div class="container mb-3 pb-3 pb-md-0 text-center" style="font-size: 12px; color: #a9a9a9;">
        *By clicking on continue you agree to receiving whatsapp messages from Avishkaar
      </div>
    </div>
  </form>
</template>

<script>
import { mapActions } from "vuex";
import { validationMixin } from 'vuelidate'
import { minLength, maxLength, numeric, required } from 'vuelidate/lib/validators'

export default {
  name: "DeliveryOtp",
  data() {
    return {
      interval: undefined, // variable for setting interval function
      otp: '',
      resendDisabled: false, // resend disabled at start for 1 minute
      secondsLeft: 59,
      invalidOTP: false, // for invalid otp error message
    }
  },
  mixins: [validationMixin],
  validations: {
    otp: {
      numeric,
      maxLength: maxLength(6),
      minLength: minLength(6),
      required,
    }
  },
  props: ["phone", "is-logged-in"],
  mounted() {
    // send otp first time as the otp step is started
    // otp will be sent only if user is not logged-in
    if (this.isLoggedIn) this.$emit('otp');
    else this.otpSend();
  },
  methods: {
    ...mapActions(["sendOTP"]),
    otpSubmit() {
      if(localStorage.getItem('otp') == this.$v.otp.$model) this.$emit('otp');
      else this.invalidOTP = true;
    },
    otpSend() {
      this.sendOTP(`+91${this.phone}`);
      this.secondsLeft = 59;
      this.resendDisabled = true;

      // set seconds timer
      this.interval = setInterval(() => {
        this.secondsLeft--;
        if(this.secondsLeft==0) {
          this.resendDisabled = false;
          clearInterval(this.interval);
        }
      }, 1000)
    },
  },
  beforeDestroy() {
    // clear the timer before going to next step
    clearInterval(this.interval)
  }
}
</script>

<style scoped>
  .box > .header > .step {
    color:#fff;
    border-radius: 1000px;
    background: #f36f2e;
    height: 36px;
    width: 36px;

    display: flex;
    justify-content: center;
    align-items: center;
  }

  .box > .content {
    overflow: hidden;
    /* min-height: 200px; */
  }

  .box > .content .form {
    min-height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .input-group {
    position: relative;
  }

  .input-group > .label {
    position: absolute;
  }
  .input-group > .text:hover, .label:hover {
    cursor: pointer;
  }

  .text {
    outline: none;
    padding: 10px;
    border-radius: 4px;
    border: solid 1px #A0A0A0;
  }

  .label {
    padding: 11px;
    top: 0;
    left: 0;
    transition: all 0.5s;
    color: #A0A0A0;
    white-space: nowrap;
  }

  .text:focus {
    border: solid 1px #F36F2E;
  }

  .text:focus ~ .label {
    padding: 0 4px;
    font-size: 0.8rem;
    top: -0.4rem;
    left: 0.4rem;
    background: #fff;
    color: #F36F2E;
    
    transition: all 0.5s;
  }

  .filled {
    padding: 0 4px;
    font-size: 0.8rem;
    top: -0.4rem;
    left: 0.4rem;
    background: #fff;
  }

  /* styling for resend button */
  button.resend:not([disabled]) {
    cursor: pointer;
    color: #f36f2e;
  }

  button.resend {
    background: inherit;
    border: none;
    outline: none;
  }
</style>